import React, {Component} from 'react';

const TeamBoxes = (props) => {
    const styleContent = {
        display: "flex"
    }
    const teamBoxes = props.teamBoxes;
     const boxes = teamBoxes.map((box, id) => {
        const social = box.social.map((link, id)=>{
            return (
                <a href={link.target} key={id} className="flexRow" target="_blank" rel="noopener"><img src={link.img} alt={link.type}/></a>
            )
        })
        return (
            <div className={"teamBoxWrapper " + props.classes} key={id}>
                <button className="teamBoxBtn flexColumn" onClick={props.click} key={id}>
                    <img src={box.profilePic} alt={box.name} />
                    <div className="teamBoxTitles turnBlack centerText">
                        <h3 className="bodyFont bold turnBlack">{box.name}</h3>
                        <h4 className="smallFont turnBlack">{box.title}</h4>
                    </div>
                </button>
                <div className="teamBoxContent flexColumn hide" id={id} onClick={props.stopPropagation}>
                    <p className="bodyFont centerText">{box.content}</p>
                    <div className="teamConnect flexRow">
                        <p className="bodyFont boldest">{"Connect with " + box.name + ": "}</p>
                        <div className="teamSocial flexRow">{social}</div>
                    </div>
                </div>

            </div>
        )
    })
    return(
        <div className="TeamBoxes flexRow alignStart">
            {boxes}
        </div>
    )
}

export default TeamBoxes;


// WEBPACK FOOTER //
// ./src/components/TeamBoxes.js